import { render, staticRenderFns } from "./OrderInspector.vue?vue&type=template&id=1a900646&scoped=true"
import script from "./OrderInspector.vue?vue&type=script&lang=js"
export * from "./OrderInspector.vue?vue&type=script&lang=js"
import style0 from "./OrderInspector.vue?vue&type=style&index=0&id=1a900646&scoped=true&lang=scss"
import style1 from "./OrderInspector.vue?vue&type=style&index=1&id=1a900646&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a900646",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.servis.leaseplan.cz/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a900646')) {
      api.createRecord('1a900646', component.options)
    } else {
      api.reload('1a900646', component.options)
    }
    module.hot.accept("./OrderInspector.vue?vue&type=template&id=1a900646&scoped=true", function () {
      api.rerender('1a900646', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/OrderInspector.vue"
export default component.exports